module.exports = __webpack_public_path__ + "static/media/extreme.2583280e.png";